const getAdditionalInfoVal = (additionalInfo: any[], key: string): string | null => {
    if (!Array.isArray(additionalInfo)) return null;
    return additionalInfo.find((item: any) => item.name === key)?.value ?? null;
  };

export const generateLongreadPostParams = (post: any) => {
    let params = {}
    if (post.style === 'as_cover') {
        params = {
            ...params, 
            titlePosition: post?.titlePosition || '', 
            isCardImport: getAdditionalInfoVal(post?.additionalInfo, 'isCardImport') || false,
        }
    }

    return params
}const getAdditionalInfoVal = (additionalInfo: any[], key: string): string | null => {
    if (!Array.isArray(additionalInfo)) return null;
    return additionalInfo.find((item: any) => item.name === key)?.value ?? null;
  };

export const generateLongreadPostParams = (post: any) => {
    let params = {}
    if (post.style === 'as_cover') {
        params = {
            ...params, 
            titlePosition: post?.titlePosition || '', 
            isCardImport: getAdditionalInfoVal(post?.additionalInfo, 'isCardImport') || false,
        }
    }

    return params
}